// https://developers.klaviyo.com/en/docs/guide_to_integrating_a_platform_without_a_pre_built_klaviyo_integration
export enum KlMetrics {
  active_on_site = 'Active on Site',
  view_item = 'Viewed Product',
  add_to_cart = 'Added to Cart',
  checkout = 'Started Checkout',
}
